import React from 'react';
 
import InputWithLabel from '../../shared/components/InputWithLabel';

const RegisterPageInput = (props) => {
    const {mail,setMail,password,setPassword,username,setUsername}=props;
  return (
    <>
    <InputWithLabel label="Username"
    value={username} placeholder="Введите username" type="text" setValue={setUsername} />
    
    <InputWithLabel label="E-mail"
    value={mail} placeholder="Введите e-mail" type="text" setValue={setMail} />
    
    <InputWithLabel label="Пароль"
    value={password} placeholder="Введите пароль" type="password" setValue={setPassword} />
      
    </>
  )
}

export default RegisterPageInput
